export const roleBaseAccessconfig = {
  IM: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
  ],
  NM: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
  ],
  NH: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
  ],
  RM: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
  ],
  QC: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
  ],
  BSTL: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    "/vendorOnboarding",
    "/createCase",
    "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
  ],
  BS: [
    "/home",
    "/assignBlock",
    "/caseDescription",
    // "/invoice-approval",
    "/re-assign/:vendorId/:reassignType",
    "/caseManagement",
    // "/vendorOnboarding",
    "/createCase",
    // "/approval",
    "/reports",
    "/fmr-report-download",
    "/caseSearch",
    "/caseSearchResult",
    "/caseSearchView",
    "/caseHistory",
  ],
  MIS: ["/reports"],
  MRA: ["/reports"],
};
